import { render, staticRenderFns } from "./AdminAgenda.vue?vue&type=template&id=0a3bee2c&scoped=true&"
import script from "./AdminAgenda.vue?vue&type=script&lang=js&"
export * from "./AdminAgenda.vue?vue&type=script&lang=js&"
import style0 from "./AdminAgenda.vue?vue&type=style&index=0&id=0a3bee2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3bee2c",
  null
  
)

export default component.exports